import React, { useState, useEffect } from 'react';
import Footer from './../component/layout/Footer';
import Header from '../component/layout/Header';
import Page from '../component/utility/Page';
import axios from 'axios';
import { mainurl } from '../Mainurl';

import { Row, Col, Card, CardBody } from 'reactstrap';
import { GiFarmer, GiField, GiWheat, GiGoat } from 'react-icons/gi';

import { Doughnut, Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

const Home = () => {

    const [stats, setStats] = useState([]);

    useEffect(() => {
        get_db_stats();
    }, []);

    const get_db_stats = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id') }];
        axios({
            method: 'post',
            url: mainurl + 'Master/user_db_m2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setStats(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    // Parse numeric values from strings like "4367.00 " or "362.26 Acre"
    const parseVal = (val) => {
        if (!val) return 0;
        return parseFloat(val) || 0;
    };

    const farmer = parseVal(stats?.[0]?.key_value);
    const area = parseVal(stats?.[1]?.key_value);
    const animals = parseVal(stats?.[2]?.key_value);
    const harvest = parseVal(stats?.[3]?.key_value);

    // Bar Chart: Overview of all stats
    const barData = {
        labels: ['Total Farmer', 'Cultivation Area (Acre)', 'Animal Count', 'Harvesting (Kg)'],
        datasets: [
            {
                label: 'Statistics Overview',
                data: [farmer, area, animals, harvest],
                backgroundColor: [
                    'rgba(46, 49, 146, 0.75)',
                    'rgba(39, 174, 96, 0.75)',
                    'rgba(231, 76, 60, 0.75)',
                    'rgba(243, 156, 18, 0.75)',
                ],
                borderColor: [
                    '#2e3192',
                    '#27ae60',
                    '#e74c3c',
                    '#f39c12',
                ],
                borderWidth: 2,
                borderRadius: 6,
            },
        ],
    };

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: {
                display: true,
                text: 'Farm Statistics Overview',
                font: { size: 15, weight: 'bold' },
                color: '#2e3192',
            },
            tooltip: {
                callbacks: {
                    label: (ctx) => ` ${ctx.parsed.y.toLocaleString()}`,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: { color: 'rgba(0,0,0,0.05)' },
                ticks: { color: '#555' },
            },
            x: {
                grid: { display: false },
                ticks: { color: '#555' },
            },
        },
    };

    // Doughnut Chart: Farmer vs Animals ratio (meaningful comparison)
    const doughnutData = {
        labels: ['Total Farmers', 'Animal Count'],
        datasets: [
            {
                data: [farmer, animals],
                backgroundColor: ['#2e3192', '#e74c3c'],
                hoverBackgroundColor: ['#3d42c7', '#c0392b'],
                borderWidth: 0,
            },
        ],
    };

    const doughnutOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    padding: 16,
                    font: { size: 13 },
                    color: '#444',
                },
            },
            title: {
                display: true,
                text: 'Farmer vs Animal Ratio',
                font: { size: 15, weight: 'bold' },
                color: '#2e3192',
            },
            tooltip: {
                callbacks: {
                    label: (ctx) => ` ${ctx.label}: ${ctx.parsed.toLocaleString()}`,
                },
            },
        },
        cutout: '65%',
    };

    // Doughnut Chart 2: Area vs Harvest
    const doughnutData2 = {
        labels: ['Cultivation Area (Acre)', 'Harvesting (Kg)'],
        datasets: [
            {
                data: [area || 1, harvest || 1],
                backgroundColor: ['#27ae60', '#f39c12'],
                hoverBackgroundColor: ['#1e8449', '#d68910'],
                borderWidth: 0,
            },
        ],
    };

    const doughnutOptions2 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    padding: 16,
                    font: { size: 13 },
                    color: '#444',
                },
            },
            title: {
                display: true,
                text: 'Area vs Harvest',
                font: { size: 15, weight: 'bold' },
                color: '#27ae60',
            },
            tooltip: {
                callbacks: {
                    label: (ctx) => ` ${ctx.label}: ${ctx.parsed.toLocaleString()}`,
                },
            },
        },
        cutout: '65%',
    };

    return (
        <>
            <Header />
            <Page title='' breadcrumbs=''>

                {/* Top Stats Cards */}
                <Row className='p-3 mb-3'>
                    <Col md={3}>
                        <div className='dashboard_topbox'>
                            <Row>
                                <Col xs={8}>
                                    <div className="fs-16">Total Farmer</div>
                                    <div className='text-primary fs-25 mt-1'>
                                        {stats?.[0]?.key_value ? Number(parseVal(stats?.[0]?.key_value)).toLocaleString() : '00'}
                                    </div>
                                </Col>
                                <Col xs={4}>
                                    <GiFarmer className='mt-2' size={55} color="#2e3192" />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='dashboard_topbox'>
                            <Row>
                                <Col xs={8}>
                                    <div className="fs-16">Cultivation Area</div>
                                    <div className='text-primary fs-25 mt-1'>
                                        {stats?.[1]?.key_value ? stats?.[1]?.key_value : '00'}
                                    </div>
                                </Col>
                                <Col xs={4}>
                                    <GiField className='mt-2' size={55} color="#2e3192" />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='dashboard_topbox'>
                            <Row>
                                <Col xs={8}>
                                    <div className="fs-16">Animal Count</div>
                                    <div className='text-primary fs-25 mt-1'>
                                        {stats?.[2]?.key_value ? Number(parseVal(stats?.[2]?.key_value)).toLocaleString() : '00'}
                                    </div>
                                </Col>
                                <Col xs={4}>
                                    <GiGoat className='mt-2' size={55} color="#2e3192" />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='dashboard_topbox'>
                            <Row>
                                <Col xs={8}>
                                    <div className="fs-16">Total Harvesting</div>
                                    <div className='text-primary fs-25 mt-1'>
                                        {stats?.[3]?.key_value ? stats?.[3]?.key_value : '00'}
                                    </div>
                                </Col>
                                <Col xs={4}>
                                    <GiWheat className='mt-2' size={55} color="#2e3192" />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                {/* Charts Row */}
                <Row className='px-3 mb-3'>

                    {/* Bar Chart */}
                    <Col md={6} className='mb-3'>
                        <Card className='shadow-sm h-100'>
                            <CardBody>
                                <div style={{ height: '300px' }}>
                                    <Bar data={barData} options={barOptions} />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    {/* Doughnut Charts */}
                    <Col md={3} className='mb-3'>
                        <Card className='shadow-sm h-100'>
                            <CardBody>
                                <div style={{ height: '300px' }}>
                                    <Doughnut data={doughnutData} options={doughnutOptions} />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col md={3} className='mb-3'>
                        <Card className='shadow-sm h-100'>
                            <CardBody>
                                <div style={{ height: '300px' }}>
                                    <Doughnut data={doughnutData2} options={doughnutOptions2} />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>

                </Row>
            </Page>
            <Footer />
        </>
    );
};

export default Home;